import React from "react";
import { Button, Row, Col } from "antd";
import { SettingOutlined, FilePdfOutlined, DeleteOutlined, ShareAltOutlined } from "@ant-design/icons";

const ReportHeader = ({
    title,
    onGeneratePDF,
    generatingPDF,
    onOpenSettings,
    onDeleteReport,
    deletingReport,
    onShareReport
}) => {
    return (
        <div style={{
            background: 'white',
            padding: '20px 24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            marginBottom: '24px',
        }}>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={8}>
                    <h2 style={{ margin: 0 }}>{title}</h2>
                </Col>
                <Col xs={24} md={16} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <Button
                        type="primary"
                        className="btn-GeneratePDF"
                        icon={<FilePdfOutlined />}
                        loading={generatingPDF}
                        onClick={onGeneratePDF}
                    >
                        {generatingPDF ? 'Generating...' : 'Generate PDF'}
                    </Button>
                    <Button 
                        icon={<ShareAltOutlined />} 
                        onClick={onShareReport}
                        style={{ backgroundColor: '#f0f0f0', border: '1px solid #d9d9d9' }}
                    >
                        Share Report
                    </Button>
                    <Button icon={<SettingOutlined />} onClick={onOpenSettings}>
                        Manage Settings
                    </Button>
                    <Button 
                        danger 
                        icon={<DeleteOutlined />} 
                        onClick={onDeleteReport}
                        loading={deletingReport}
                    >
                        Delete Report
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default ReportHeader;


